import React, {useState} from 'react';
import './GrantChestPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {API_BASE} from '../../../utils/apiConfig';
import {getChestIconPath} from '../../../utils/inventory/getChestIconPath';
import {getChestDisplayName} from '../../../utils/inventory/getChestDisplayName';
import {CHESTS} from '../../../constants/chests';
import {MENU_SOUND_MANAGER} from "../../../scenes/MenuSoundManager";

const CHEST_IDS = Object.values(CHESTS);

function GrantChestItem({chestId, targetUserId}) {
  const [granting, setGranting] = useState(false);
  const [grantedCount, setGrantedCount] = useState(null);

  const handleGrant = async (count) => {
    if (granting) return;

    const soundManager = MENU_SOUND_MANAGER;
    if (soundManager?.playChestOpen) {
      soundManager.playChestOpen();
    }

    setGranting(true);
    setGrantedCount(null);
    try {
      const response = await fetch(`${API_BASE}/admin/grant-chest`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({targetUserId, chestId, count}),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.error || 'Failed to grant chest');
      }

      setGrantedCount(count);
      setTimeout(() => setGrantedCount(null), 1200);
    } catch (e) {
      console.error('Grant chest error', e);
      alert(e.message || 'Не удалось начислить сундук');
    } finally {
      setGranting(false);
    }
  };

  return (
    <div
      className={`inventory-item inventory-chest-item grant-chest-item ${granting ? 'grant-chest-item_granting' : ''}`}
    >
      <img
        className="inventory-chest-icon grant-chest-icon"
        src={getChestIconPath(chestId)}
        alt={getChestDisplayName(chestId)}
      />
      <div className="grant-chest-buttons">
        <button
          className="grant-chest-button"
          onClick={() => handleGrant(1)}
          disabled={granting}
          type="button"
        >
          x1
        </button>
        <button
          className="grant-chest-button grant-chest-button_bulk"
          onClick={() => handleGrant(10)}
          disabled={granting}
          type="button"
        >
          x10
        </button>
      </div>
      {grantedCount !== null && (
        <div className="grant-chest-checkmark">+{grantedCount}</div>
      )}
    </div>
  );
}

function GrantChestPage({targetUserId, targetUserName, onBack}) {
  usePageAnalytics('GrantChestPage');

  return (
    <>
      <h1 className="lobby-page-title grant-chest-page-title">
        Начислить сундук
        {targetUserName && <span className="grant-chest-page-subtitle">{targetUserName}</span>}
      </h1>

      <div className="inventory-grid grant-chest-grid">
        {CHEST_IDS.map((chestId) => (
          <GrantChestItem key={chestId} chestId={chestId} targetUserId={targetUserId}/>
        ))}
      </div>

      <div className="main-menu-buttons grant-chest-page-buttons">
        <PageButton onClick={onBack} pageId="GrantChestPage" buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default GrantChestPage;
